/**
 * Accounting Hub text-domain-bound i18n helpers.
 *
 * Binds the accounting-hub text domain (must match the domain registered in PHP) to
 * the shared @wordpress/i18n factory in @tpct/admin-ui and re-exports the helpers so
 * call sites stay `import { __ } from '.../i18n'`.
 */
import { createI18n } from '@tpct/admin-ui/i18n/createI18n';

const i18n = createI18n('accounting-hub');

export const __ = i18n.__;
export const _x_ = i18n._x_;
export const _n_ = i18n._n_;
export const sprintf = i18n.sprintf;
